import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskSendToGtNetService } from './send-to-gtnet-service/task-send-to-gt-net.service';

@NgModule({
  imports: [CommonModule],
  providers: [TaskSendToGtNetService],
})
export class GTNetModule {}
